import React from "react";

interface ContractTextProps {
  guardianName?: string;
  guardianNickname?: string;
  guardianEmail?: string;
  guardianPhone?: string;
  guardianAddress?: string;
  petName?: string;
  petBirthday?: string;
  petBreed?: string;
  petWeight?: string;
  petNeutered?: string;
  petVaccinations?: string;
  petPersonality?: string;
  petAllergies?: string;
  petOther?: string;
  companyName?: string;
  businessNumber?: string;
  contractDate?: string;
  signatureFileUrl?: string;
}

const ContractText: React.FC<ContractTextProps> = ({
  guardianName,
  guardianNickname,
  guardianEmail,
  guardianPhone,
  guardianAddress,
  petName,
  petBirthday,
  petBreed,
  petWeight,
  petNeutered,
  petVaccinations,
  petPersonality,
  petAllergies,
  petOther,
  companyName,
  businessNumber,
  contractDate,
  signatureFileUrl,
}) => {
  console.log("signatureFileUrl", signatureFileUrl);
  return (
    <div className="flex justify-center items-start p-6 min-h-screen bg-gray-100">
      <article className="overflow-hidden w-full max-w-screen-sm bg-white rounded-lg">
        <header className="text-center">
          <h1 className="text-lg font-semibold">
            반려동물 위탁보호 신청계약서
          </h1>
        </header>

        <section className="px-6 py-4 text-sm leading-relaxed text-gray-700">
          <p className="mb-3">
            본 신청서의 목적은 반려동물의 보호자의 사정으로 인하여 일정 기간동안
            수탁보호자에게 반려동물을 위탁하여 보호를 신청하고 수탁보호자가
            제공하는 서비스를 이용하기 위함입니다.
          </p>

          <p className="mb-3">
            본 신청에는 반려동물 보호자의 개인정보와 지정한 반려동물의 정보가
            취합되어 관리되며, 해당 정보는 원활한 서비스를 위하여 수탁보호자에게
            정보가 제공됩니다.
          </p>

          <p className="mb-3">
            보호자는 반려동물을 보호하고 수탁보호자가 제공하는 서비스를 영위하는
            것에 있어 수탁보호자가 지정 및 영수한 금액을 선불로 지급한 후
            반려동물이 수탁되는 시점부터 본 계약의 효력이 발생됩니다.
          </p>

          <p className="mb-3">
            본 계약은 날인일로부터 수탁계약약정 1년간 계약의 효력을 가지며,
            1년이 지난 시점에는 별도의 날인을 통하여 계약을 갱신합니다.
          </p>

          <p className="mb-3 font-medium">
            본 계약의 날인 일 :{" "}
            <span className="font-semibold">{contractDate}</span>
          </p>
        </section>

        <section className="px-6 pb-6">
          <div className="text-sm text-gray-700 prose">
            <ol className="space-y-2 list-decimal list-inside">
              <li>
                반려동물의 주요 먹이(주 사료, 간식 등의 일체)는 모두 보호자가
                전달한 범위에서 급여됩니다.
              </li>
              <li>
                만약 반려동물의 주요 먹이가 전달되지 않을 경우 보호자가 지정한
                범위의 사료만을 제한적으로 급여하며, 이 때 발생하는 모든 금액은
                보호자가 지불합니다.
              </li>
              <li>
                수탁보호자와의 약정기간 종료 이후 10일 이상 초과될 경우
                수탁보호자는 보호중인 반려동물을 임의로 처리할 수 있는 권리를
                가집니다.
              </li>
              <li>
                수탁보호자는 수탁한 반려동물을 보호하는 과정에서 교통사고, 분실
                등의 사고 발생 시 모든 책임을 가지며, 보호자에게 손해배상을
                하여야 합니다.
              </li>
              <li>
                반려동물의 보호 과정에서 천재지변, 전쟁, 폭동, 테러, 시민봉기 및
                기타 불가항력적인 사유로 인한 손해는 상호 책임을 지지 않습니다.
              </li>
            </ol>
          </div>
        </section>

        <section className="px-6 pb-6">
          <p className="mb-3 text-sm text-gray-700">
            본 계약이 체결될 경우 보호자는 아래 각 정보를 수탁보호자에게
            제공하며, 1년간 보유합니다.
          </p>

          <div className="grid grid-cols-1 gap-4">
            {/* 수탁자 정보 */}
            <h3 className="font-semibold">수탁자 정보</h3>
            <div className="text-sm bg-gray-50 rounded border border-gray-200">
              <table className="w-full text-sm border-collapse">
                <tbody>
                  <tr className="border-b border-gray-300">
                    <td className="py-2 w-1/3 font-medium text-center border-r border-gray-300">
                      수탁업체 명
                    </td>
                    <td className="py-2 pl-3">{companyName}</td>
                  </tr>
                  <tr>
                    <td className="py-2 font-medium text-center border-r border-gray-300">
                      사업자번호
                    </td>
                    <td className="py-2 pl-3">{businessNumber}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* 보호자 정보 */}
            <h3 className="font-semibold">보호자 정보</h3>
            <div className="text-sm bg-gray-50 rounded border border-gray-200">
              <table className="w-full text-sm border-collapse">
                <tbody>
                  <tr className="border-b border-gray-300">
                    <td className="py-2 w-1/3 font-medium text-center border-r border-gray-300">
                      이름
                    </td>
                    <td className="py-2 pl-3">{guardianName}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-2 font-medium text-center border-r border-gray-300">
                      닉네임
                    </td>
                    <td className="py-2 pl-3">{guardianNickname}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-2 font-medium text-center border-r border-gray-300">
                      이메일
                    </td>
                    <td className="py-2 pl-3">{guardianEmail}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-2 font-medium text-center border-r border-gray-300">
                      전화번호
                    </td>
                    <td className="py-2 pl-3">{guardianPhone}</td>
                  </tr>
                  <tr>
                    <td className="py-2 font-medium text-center border-r border-gray-300">
                      주소
                    </td>
                    <td className="py-2 pl-3">{guardianAddress}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* 반려동물 정보 */}
            <h3 className="font-semibold">반려동물 정보</h3>
            <div className="text-sm bg-gray-50 rounded border border-gray-200">
              <table className="w-full text-sm border-collapse">
                <tbody>
                  <tr className="border-b border-gray-300">
                    <td className="py-2 w-1/3 font-medium text-center border-r border-gray-300">
                      이름
                    </td>
                    <td className="py-2 pl-3">{petName}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-2 font-medium text-center border-r border-gray-300">
                      생년월일
                    </td>
                    <td className="py-2 pl-3">{petBirthday}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-2 font-medium text-center border-r border-gray-300">
                      품종
                    </td>
                    <td className="py-2 pl-3">{petBreed}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-2 font-medium text-center border-r border-gray-300">
                      몸무게
                    </td>
                    <td className="py-2 pl-3">{petWeight}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-2 font-medium text-center border-r border-gray-300">
                      중성화
                    </td>
                    <td className="py-2 pl-3">{petNeutered}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-2 font-medium text-center border-r border-gray-300">
                      1년 내 접종
                    </td>
                    <td className="py-2 pl-3">{petVaccinations}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-2 font-medium text-center border-r border-gray-300">
                      성격/사회성
                    </td>
                    <td className="py-2 pl-3">{petPersonality}</td>
                  </tr>
                  <tr className="border-b border-gray-300">
                    <td className="py-2 font-medium text-center border-r border-gray-300">
                      알레르기
                    </td>
                    <td className="py-2 pl-3">{petAllergies}</td>
                  </tr>
                  <tr>
                    <td className="py-2 font-medium text-center border-r border-gray-300">
                      기타
                    </td>
                    <td className="py-2 pl-3">{petOther}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
        <section className="px-6 pb-6">
          {signatureFileUrl && (
            <div className="flex justify-center">
              <img src={signatureFileUrl} alt="서명" />
            </div>
          )}
        </section>
      </article>
    </div>
  );
};

export default ContractText;
